import { Backdrop, CircularProgress, Skeleton } from "@mui/material";
import React from "react";

export const onShowLoading = (isShow: boolean = true) => (
  <Backdrop
    sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
    open={isShow}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export const FieldLoading = React.memo(() => (
    <div>
      <div style={{ width: "100%" }} className="mt-2">
        <Skeleton
          height={40}
          width="100%"
          variant="rectangular"
          key="detail-skeleton"
        />
      </div>
      <div style={{ width: "100%" }} className="mt-3">
        <Skeleton
          height={40}
          width="100%"
          variant="rectangular"
          key="detail-skeleton"
        />
      </div>
    </div>
  ));
  
  export const AvatarLoading = () => (
    <Skeleton variant="circular" width={40} height={40} />
  );
  
  export const TitleLoading = () => (
    <Skeleton animation="wave" height={20} width="50%" />
  );
  
  export const SubTitleLoading = () => (
    <Skeleton animation="wave" height={10} width="30%" />
  );
  
  export const CaptionLoading = () => (
    <Skeleton animation="wave" height={10} width="20%" />
  );
  
  // export const TransactionLoading = () => (
  //   <div>
  //     {[...Array(5)].map((item) => {
  //       return (
  //         <div style={{ display: "flex", width: "100%", height: "85vh", justifyContent: "center" }}>
  //           <CircularProgress color="inherit" />
  //         </div>
  //       );
  //     })}
  //   </div>
  // );
  
  export const ObaLoading = () => (
    <div>
      {[...Array(2)].map((item) => {
        return (
          <div
            className="transaksiWrapper"
            key="skeleton_loading"
            id="btn_transaction_card"
          >
            <div className="transaksiCard">
              <div className="transaction-header">
                <div className="transaction-image">
                  <AvatarLoading />
                </div>
                <div className="transaction-title">
                  <TitleLoading />
                  <SubTitleLoading />
                </div>
                <div className="transaction-status">
                  <Skeleton animation="wave" height={10} width="30%" />
                </div>
              </div>
              <div>
                <hr className="borderLine" />
              </div>
              <div className="transaction-total">
                <CaptionLoading />
                <SubTitleLoading />
              </div>
            </div>
            <br />
          </div>
        );
      })}
    </div>
  );
  
  export const ObaPreLoading = () => (
    <div>
      {[...Array(3)].map((item) => {
        return (
          <div
            className="mt-2 transaksiWrapper"
            key="skeleton_loading"
            id="btn_transaction_card"
          >
            <div className="transaction-header">
              <div className="transaction-image">
                <AvatarLoading />
              </div>
              <div className="transaction-title">
                <TitleLoading />
                <SubTitleLoading />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
  
  export const PrepaidLoading = () => (
    <div className="cardProduct">
      <div style={{ marginBottom: 6 }}>
        <Skeleton animation="wave" height={20} width="50%" variant="text" />
      </div>
      <div style={{ marginBottom: 6 }}>
        <Skeleton animation="wave" height={20} width="100%" variant="text" />
      </div>
      <div>
        <Skeleton animation="wave" height={20} width="100%" variant="text" />
      </div>
    </div>
  );
  